// extracted by mini-css-extract-plugin
export default {"characters":"CharacterList_characters__sZORK"};